import "./css/HomePage.css";
import logo from '../Assests/isecurion1.png';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from "react";
import demo from "../Assests/demo.png"
import { toast } from "react-toastify";
import bugtraq from '../Assests/Frame 495.png'
import { useAuth } from "../../src/Context/UserContext"
import mainpageBG from "../Assests/mainPage.png"
import Dashboard from '../Assests/Dashboard.png';
import { section2Data } from "../constants/section2Data";
import { section3Data } from "../constants/section3Data";
import ProjectDashboard from "../Assests/ProjectDashboard.png";
import GroupImg from "../Assests/GroupImg.png"
import AIrobot from "../Assests/AIrobot.png"
import { section9Data } from "../constants/section9Data";
import { url } from "../constants/url"
import AOS from "aos";
import "aos/dist/aos.css";
import buglogo from '../Assests/buglogo.png';



const HomePage = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [contact, setContact] = useState('')
    const [company, setCompany] = useState('')
    const [showNameError, setShownameError] = useState(false)
    const [showEmailError, setShowEmailError] = useState(false)
    const [showContactError, setShowContactError] = useState(false)
    const [showCompanyError, setShowCompanyError] = useState(false)

    const [hideLogo, setHideLogo] = useState(false)

    const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email); //xnzakiq1i1jna@yopwww.com
    const nameRegex = (name) => /^[a-zA-Z\s]{2,30}$/.test(name)
    //const phoneRegex = (contact) => /^\+?\d{1,3}?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(contact)
    const phoneRegex = (contact) => /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/.test(contact);
    const { onClose, handleDemo, showDemo } = useAuth()
    const specialChars = /[0-9][!@#$%^&*(),.?":{}|<>]/;


    const handleSubmit = async () => {
        if (name === "") {
            return setShownameError("Name is required")
        }
        if (!nameRegex(name)) {
            return setShownameError("Please enter valid characters")
        }
        if (email === "") {
            return setShowEmailError("Email is required")
        }
        if (!validateEmail(email)) {
            return setShowEmailError("Please enter valid email")
        }
        if (contact === "") {
            return setShowContactError("Contact number is required")
        }
        if (!phoneRegex(contact)) {
            return setShowContactError("Please enter valid contact number")
        }
        if (company === "") {
            return setShowCompanyError("Company name is required")
        }
        try {
            const response = await fetch(`${url}/demodetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    name, email, contact, company
                })
            })

            if (response.status === 200) {
                toast.success("Demo Request sent", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                setName('')
                setEmail('')
                setCompany('')
                setContact('')
                return
            }

            if (response.status === 400) {
                toast.error("Invalid Input Field", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                return
            }

        }
        catch (error) {
            console.log(error)
        }
    }

    const handleClose = () => {
        onClose()
        setCompany('')
        setContact('')
        setEmail('')
        setName('')
        setShownameError("")
        setShowContactError("")
        setShowCompanyError("")
        setShowEmailError("")
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setHideLogo(scrollTop < 50);
        };

        handleScroll()

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (showDemo) {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        } else {
            document.body.style.overflow = '';
            document.body.style.height = '';
        }
        return () => {
            document.body.style.overflow = '';
            document.body.style.height = '';
        };
    }, [showDemo]);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <div className="homepage">
            <div className="navbar">
                <div className="navbar_items">
                    <img
                        src={logo}
                        alt="Isecurion Logo"
                        className={`isecurion_logo ${hideLogo ? 'fade-in' : 'fade-out'}`}
                        data-testid='homepage_image'
                    />
                    <p className={`vertical-line ${hideLogo ? 'hide-out' : 'hide-line'}`}></p>
                    <img
                        src={buglogo}
                        alt="Vulnytics"
                        className={`bugtraq_logo ${hideLogo ? 'slide-reset' : 'slide-left'}`}
                    />
                </div>

                <Link to="/login">
                    <button className="navbar_button">Sign in</button>
                </Link>
            </div>
            <div className="main_page_bgcolor">
                <div className="main_page" >

                    <div className="main_page_content">
                        <h1 className="main_page_title">Smarter Pentesting. Streamlined Security. Real-Time Control with Vulnytics.</h1>
                        <p className="main_page_description">
                            Unify vulnerability detection, risk prioritization and remediation with an AI-powered VMaaS + PTaaS platform built for modern security teams.
                        </p>
                        <button className="main_page_button" onClick={handleDemo}>Book a Demo</button>
                    </div>

                    <div style={{ backgroundImage: `url(${mainpageBG})` }} className="main_BG">

                    </div>
                    {showDemo && (
                        <div className="Demo_layout">
                            <div className="main_Demo">
                                <div className="main_Demo_content">
                                    <button onClick={handleClose} className="close_button">
                                        <Icon icon="material-symbols:close" width="20" height="20" />
                                    </button>
                                    <h1>Explore Our Platform in Real Time</h1>
                                    <div className="demo_content">
                                        <div className="left_side">
                                            <img src={demo} alt="demo illustration" className="left_side_image"></img>
                                            <p>By submitting my information, I confirm that I have read and understood the ISECURION  <Link to="https://isecurion.com/privacy-policy.html">Privacy & Policy</Link>
                                                <span> </span>I consent to the use of my information to contact me via email, phone, or SMS regarding my inquiry, with the option to opt out at any time.
                                            </p>
                                        </div>
                                        <div className="right_side">
                                            <div className="form_row">
                                                <label>Name</label>
                                                <div className="handleError">
                                                    <input type="text" placeholder="Enter your name" style={{ marginBottom: "8px" }} value={name}

                                                        onChange={(e) => {
                                                            setName(e.target.value)
                                                            setShownameError('')
                                                        }} />
                                                    {showNameError && <p>{showNameError}</p>}
                                                </div>
                                                <div className="form_row">
                                                    <label>Email</label>
                                                    <div className="handleError">
                                                        <input type="email" placeholder="Enter your email" value={email} onChange={(e) => {
                                                            setEmail(e.target.value)
                                                            setShowEmailError('')
                                                        }} />
                                                        {showEmailError && <p>{showEmailError}</p>}
                                                    </div>
                                                </div>
                                                <div className="form_row">
                                                    <label>Contact Number</label>
                                                    <div className="handleError">
                                                        <input type="tel" placeholder="Enter your contact number" value={contact} onChange={(e) => {
                                                            setContact(e.target.value)
                                                            setShowContactError('')
                                                        }} />
                                                        {showContactError && <p>{showContactError}</p>}
                                                    </div>
                                                </div>
                                                <div className="form_row">
                                                    <label>Company Name</label>
                                                    <div className="handleError">
                                                        <input type="text" placeholder="Enter your company name" value={company} onChange={(e) => {
                                                            setCompany(e.target.value)
                                                            setShowCompanyError('')
                                                        }} />
                                                        {showCompanyError && <p>{showCompanyError}</p>}
                                                    </div>
                                                </div>
                                                <button type="button" onClick={handleSubmit}>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="section1_main">
                <div className="section1" >
                    <div className="section1_content" data-aos="fade-up">
                        <h1><span style={{ color: '#F8B179' }}>Real-Time </span>Visibility Into Your Workflow</h1>
                        <p>Streamline your workflow with powerful, intuitive tool that ensure every team member stays organize, aligned, and focused on their tasks.</p>
                    </div>
                    <div className="wrap_dashbaord_image" >
                        <img src={Dashboard} alt="Dashboard" className="section1_image" data-aos="fade-up" />
                    </div>
                </div>
            </div>
            <div className="section2_main">
                <div className="section2" data-aos="fade-up">
                    <h2>Why Vulnytics? Here’s What Sets Us Apart</h2>
                    <div className="section2_cards">
                        {section2Data.map((item, index) => (
                            <div className="section2_card" key={index}>
                                <div className="section2_card_image">
                                    <Icon icon={item.image} />
                                </div>
                                <div className="section2_card_text">
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="section3" >
                <h2 data-aos="fade-up">Our Workflow, Your Security</h2>
                <div className="section3_content" data-aos="fade-up">

                    <div className="section3_item" >
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <p>Project Onboarding & Scope Definition</p>
                            </div>
                            <div class="flip-card-back" style={{ backgroundColor: '#4ACDEE' }}>
                                <div className="custom-arrow"></div>
                                <p>Gather requirements, define assets, and establish testing scope.</p>
                            </div>
                        </div>
                    </div>

                    <div className="section3_item" >
                        <div class="flip-card-inner">
                            <div class="flip-card-front">

                                <p>Security Assessment Execution</p>
                            </div>
                            <div class="flip-card-back" style={{ backgroundColor: '#1C7ED6' }}>
                                <div className="custom-arrow"></div>
                                <p>Begin penetration testing based on defined parameters and timelines.</p>
                            </div>
                        </div>
                    </div>

                    <div className="section3_item" >
                        <div class="flip-card-inner">
                            <div class="flip-card-front">

                                <p>Threat Discovery & Documentation</p>
                            </div>
                            <div class="flip-card-back" style={{ backgroundColor: '#8300F5' }}>
                                <div className="custom-arrow"></div>
                                <p>Document discovered vulnerabilities with severity and context.</p>
                            </div>
                        </div>
                    </div>

                    <div className="section3_item" >
                        <div class="flip-card-inner">
                            <div class="flip-card-front">

                                <p>Finding Analysis & Reporting</p>
                            </div>
                            <div class="flip-card-back" style={{ backgroundColor: '#E03131' }}>
                                <div className="custom-arrow"></div>
                                <p>Provide a detailed, actionable report for client review.</p>
                            </div>
                        </div>
                    </div>

                    <div className="section3_item" >
                        <div class="flip-card-inner">
                            <div class="flip-card-front">

                                <p>Post-Assessment Support<br /> & Revalidation</p>
                            </div>
                            <div class="flip-card-back" style={{ backgroundColor: '#2B8A3E' }}>
                                {/* <div className="custom-arrow"></div> */}
                                <p>Support mitigation efforts and perform retesting as needed.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="section4_main">
                <div className="section4">
                    <div className="wrap_dashboard_image">
                        <img src={ProjectDashboard} alt="Project Dashboard" className="section4_image" data-aos="zoom-in" />
                    </div>
                    <div className="section4_content" data-aos="fade-up">
                        <h1 className="section4_heading" style={{ fontWeight: '600' }}>
                            <span style={{ color: '#F8B179' }}>Risk Prioritization</span><span style={{ color: '#023F78' }}> & <br />Vulnerability Management</span>
                        </h1>
                        <p className="section4_text">The Project Dashboard provides a clear overview of project progress, with a Risk Matrix to prioritize critical issues, a Status Distribution Graph to track issue stages like Identified and Closed, and a Bug Status Distribution Graph showing bug resolution statuses.
                            It ensures efficient monitoring and collaboration across teams.</p>
                    </div>
                </div>
            </div>
            <div className="section5_main">
                <div className="section5">
                    <div className="section5_content" data-aos="fade-up">
                        <h1 className="section5_heading" style={{ color: '#F8B179', fontWeight: '600' }}>Visibility
                            <span style={{ color: '#023F78', }}> Across Every Stage </span>
                        </h1>
                        <p className="section5_text">Anticipate project roadblocks before they arise with an interactive timeline that highlights task dependencies and resource load. Quickly rebalance workloads, forecast deadline shifts, and keep every stakeholder informed through dynamic schedule updates.</p>
                    </div>
                    <div className="wrap_dashboard_image">
                        <img src={GroupImg} alt="Group" className="section5_image" data-aos="zoom-in" />
                    </div>
                </div>
            </div>
            <div className="section6">
                <div className="info-card" style={{ backgroundColor: '#F4FFEB' }} data-aos="zoom-out-down">
                    <Icon icon="arcticons:asus-icon-pack-applyer" className="info-card-icon" style={{ stroke: '#000', strokeWidth: 2 }} />
                    <h3 className="info-card-title">Prioritize and Retest with Ease</h3>
                    <hr className="info-card-line" />
                    <p className="info-card-description">lick Apply Retest to select vulnerability severity and submit a retest request, streamlining issue validation and resolution.</p>
                </div>
                <div
                    className="info-card"
                    style={{ backgroundColor: '#EBFFFB' }} data-aos="zoom-out-down">

                    <Icon icon="carbon:ai-governance-tracked" className="info-card-icon" />


                    <h3 className="info-card-title">Stay Ahead in Real-Time</h3>
                    <hr className="info-card-line" />
                    <p className="info-card-description">Track vulnerabilities in real-time for instant updates, enabling swift action, clear communication, and timely resolution of critical issues.</p>
                </div>
                <div
                    className="info-card"
                    style={{ backgroundColor: '#F4FFEB' }} data-aos="zoom-out-down">
                    <Icon icon="mdi-light:message-text" className="info-card-icon" />
                    <h3 className="info-card-title">Stay connected and productive</h3>
                    <hr className="info-card-line" />
                    <p className="info-card-description">Experience smooth, Real-Time communication and collaboration with a team. Stay connected effortlessly and keep projects moving forward without delay.</p>
                </div>

            </div>
            <div className="section7_main">
                <div className="section7" data-aos="fade-up">
                    <div className="section7_text">
                        <h1><span style={{ color: '#F8B179' }}>AI-Powered</span> Real-Time Security Assistance</h1>
                        <p>Enhance security with AI-powered assistance that analyzes findings, cross-references vulnerabilities, and offers actionable recommendations. Simplify details,
                            boost precision, and gain insights to keep systems secure.</p>
                    </div>
                    <div>
                        <img src={AIrobot} alt="AI Robot" className="section7_image" />
                    </div>
                </div>
            </div>
            <div className="section8_main">
                <div className="section8">
                    <h1>No risk left behind--Vulnytics helps you identify, prioritize, and act faster.</h1>
                    <p>From threat discovery to post-remediation validation, we close the loop on security gaps with real-time context and automation.</p>
                    <div className='section8_btn'>
                        <button className='first_btn' onClick={handleDemo}>Book a Demo</button>
                        <Link to="/login"><button className='second_btn'>Sign in</button></Link>
                    </div>
                </div>
            </div>
            <div className="section9_main">
                <div className="section9">
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="mdi:bullseye" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>Vulnerability Assessment & Penetration Testing</p></div>
                    </div>
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="hugeicons:internet" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>Web Application Penetration Testing</p></div>
                    </div>
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="fluent-mdl2:cell-phone" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>Mobile Application  Penetration Testing</p></div>
                    </div>
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="solar:shield-network-linear" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>Network Infrastructure Testing</p></div>
                    </div>
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="fontisto:preview" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>Source Code Review</p></div>
                    </div>
                    <div className="section9_item">
                        <div className="section9_icon">
                            <Icon icon="flowbite:api-key-outline" className="section_9_icon_data" />
                        </div>
                        <div className="section9_title"><p>API Penetration Testing</p></div>
                    </div>


                </div>
            </div>
            <div className="footer">
                <div className="footer_content">
                    <div className="footer_left_content">
                        <div className="about_company">
                            <div className="footers_logo">
                                <Icon icon="ix:about-filled" width="24" height="24" />
                            </div>
                            <div className="about_company_text">
                                About Us
                            </div>
                        </div>

                        <div className="about_company_description">
                            ISECURION is a CERT-In Empanelled and ISO 27001:2022 certified information security consulting company providing top-notch service quality, innovation, and research in the field of Information Security and Technology. We provide a unique blend of services to our customers catering to the current information security landscape.
                        </div>

                        <div className="footers_link">
                            <Link to="https://isecurion.com/privacy-policy.html" className="white-link">Privacy & Policy</Link>
                            <span className="separator"> | </span>
                            <Link to="https://isecurion.com/disclaimer.html" className="white-link">Disclaimer</Link>
                            <span className="separator"> | </span>
                            <Link to="https://isecurion.com/terms-of-use.html" className="white-link">Terms of Use</Link>
                        </div>


                    </div>

                    <div className="footer_right_content">

                        <div className="company_contact">
                            <div className="footers_logo">
                                <Icon icon="pixelarticons:contact-plus" width="20" height="20" />
                            </div>
                            <div className="contact_company_text">
                                Contact Us
                            </div>
                        </div>


                        <div className="company_location">
                            <div className="footers_logo" style={{
                                width: '30px', height: '30px',
                            }}>
                                <Icon icon="mdi:location" width="24" height="24" />
                            </div>
                            <div className="company_location_text">
                                <span>ISECURION TECHNOLOGY & CONSULTING PVT. LTD.</span>
                                <p style={{
                                    padding: '0', margin: '0', fontSize: '14px',
                                }}>
                                    #670, 2nd Floor, 6th Main Road, RBI Layout, Opposite Elita Promenade, <br />J P Nagar 7th Phase, Bengaluru - 560078, Karnataka, INDIA
                                </p>
                            </div>
                        </div>

                        <div className="company_phone_number">
                            <div className="footers_logo" style={{
                                width: '30px', height: '30px',
                            }}>
                                <Icon icon="mi:call" width="24" height="24" />
                            </div>
                            <div className="company_phone_number_text">
                                +918861201570
                            </div>
                        </div>

                        <div className="company_email">
                            <div className="footers_logo" style={{
                                width: '30px', height: '30px',
                            }}>
                                <Icon icon="material-symbols:mail" width="24" height="24" />
                            </div>
                            <div className="company_email_text">
                                info@isecurion.com
                            </div>

                        </div>

                    </div>
                </div>
                <hr className="footer_line"></hr>
                <div className="footer_socials">
                    <Link to="https://www.facebook.com/ISECURION/"><Icon icon="ic:outline-facebook" className="social_icons" /></Link>
                    <Link to="https://x.com/ISECURION"><Icon icon="ri:twitter-x-fill" className='social_icons' style={{ width: '35px', height: '35px', marginTop: '4px' }} /></Link>
                    <Link to="https://www.linkedin.com/company/isecurion"><Icon icon="ri:linkedin-fill" className="social_icons" /></Link>
                </div>

                <div className="footers_copy_right">
                    Copyright © 2026 ISECURION | All Rights Reserved
                </div>
            </div>
        </div>
    )
}

export default HomePage;
